export const ORDER_FORM_NAMESPACE = 'order-form';
